
    <ion-header>
      <ion-toolbar>
        <ion-title>
          <ion-text color="light">
            <ion-text color="light" class="fw700">{{
              "LOCATE.LOCATE" | translate
            }}</ion-text>
          </ion-text>
        </ion-title>
        <ion-buttons slot="end">
          <ion-button (click)="close()" size="small">
            <ion-icon color="light" name="close"></ion-icon>
          </ion-button>
        </ion-buttons>
      </ion-toolbar>
    </ion-header>

    <ion-content>
      <!--SELEZIONA POSIZIONE -->

      <ion-card>
        <ion-card-header>
          <ion-card-title>{{ "LOCATE.WHY" | translate }}</ion-card-title>
          <ion-card-subtitle>{{
            "LOCATE.WHY_SUBTITLE" | translate
          }}</ion-card-subtitle>
        </ion-card-header>

        <ion-card-content>
          <div *ngIf="!showChangePosition">
            <ion-icon
              src="assets/svg/position-to.svg"
              size="large"
              color="primary"
            ></ion-icon>
            <span>{{ "LOCATE.DESCRIPTION-POSITION-TO" | translate }}</span>
          </div>

          <div *ngIf="loading" class="ion-text-center">
            <h3 class="ion-margin ion-padding">{{ "LOCATE.LOADING" | translate }}</h3>
            <ion-spinner name="bubbles"></ion-spinner>
          </div>

          <div *ngIf="!loading">
            <div *ngIf="!showChangePosition">
              <h3
                class="ion-padding-top"
                *ngIf="shareService.lastUserLocation?.indirizzo"
              >
                <ion-label class="ion-margin"
                  >{{ "LOCATE.SELECTED" | translate }}
                  <b>{{ shareService.lastUserLocation?.indirizzo }}</b>

                  <ion-button color="light" (click)="changePosition()">
                    <ion-label>
                      <ion-icon size="small" name="close"></ion-icon>
                      <span class="textIcon">{{
                        "LOCATE.CHANGE" | translate
                      }}</span>
                    </ion-label></ion-button
                  >
                </ion-label>
              </h3>
            </div>

            <div *ngIf="showChangePosition || !shareService.lastUserLocation">
              <ion-grid class="ion-no-padding">
                <ion-row class="ion-align-items-center">
                  <ion-col size="12">
                    <b>{{ "LOCATE.CHANGE" | translate }}</b>
                  </ion-col>
                </ion-row>
                <ion-row class="ion-align-items-center">
                  <ion-col size="12" size-sm="5">
                    <ion-button color="light" (click)="nelleVicinanze()">
                      <ion-label>
                        <ion-icon size="small" name="locate"></ion-icon>
                        <span class="textIcon">{{
                          "LOCATE.NEAR" | translate
                        }}</span>
                      </ion-label></ion-button
                    >
                  </ion-col>

                  <ion-col size="12" size-sm="2">
                    <span>&nbsp;{{ "OR" | translate }}&nbsp;</span>
                  </ion-col>

                  <ion-col size="12" size-sm="5">
                    <ion-searchbar
                      name="ricercaLuogo"
                      [(ngModel)]="ricercaLuogo"
                      (keyup)="searchPlaces()"
                      placeholder="{{ 'LOCATE.PLACEHOLDER_TEXT' | translate }}"
                    >
                    </ion-searchbar>
                  </ion-col>
                </ion-row>
              </ion-grid>

              <div *ngIf="showInfoSearch">
                <ion-label color="danger">{{
                  "LOCATE.HOW_TO" | translate
                }}</ion-label>
              </div>

              <ion-list>
                <ion-item
                  *ngIf="ricercaLuogoList && ricercaLuogoList.length > 0"
                >
                  {{ "LOCATE.SELECT_LOCATION" | translate }}
                </ion-item>
                <ion-item-sliding>
                  <ion-item
                    *ngFor="let item of ricercaLuogoList"
                    (click)="selectPlace(item)"
                  >
                    {{ item.alternative_names }}</ion-item
                  >
                </ion-item-sliding>
              </ion-list>
            </div>
          </div>
        </ion-card-content>
      </ion-card>
    </ion-content>
  